/* eslint-disable */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { AlertAdapter } from 'pg-ui-library';
import ExpenseService from 'src/services/expense.service';

export const useAddExpense = (): UseMutationResult<any, Error, { expense: FormData }, void> =>
  useMutation((data: { expense: FormData }) => ExpenseService.addExpense(data.expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been created.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useUpdateExpense = (): UseMutationResult<any, Error, { id: string; expense: FormData }, void> =>
  useMutation(({ id, expense }: { id: string; expense: FormData }) => ExpenseService.updateExpense(id, expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useResubmitExpense = (): UseMutationResult<any, Error, { id: string; expense: FormData }, void> =>
  useMutation(({ id, expense }: { id: string; expense: FormData }) => ExpenseService.resubmitExpense(id, expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useOverrideExpense = (): UseMutationResult<any, Error, { id: string; expense: FormData }, void> =>
  useMutation(({ id, expense }: { id: string; expense: FormData }) => ExpenseService.overrideExpense(id, expense), {
    onSuccess: () => {
      AlertAdapter('Expense has been updated.', 'success');
    },
    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });

export const useApproveExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.approveExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useRejectExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.rejectExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useDeleteExpense = (): UseMutationResult<any, Error, { expenseId: string; expense: any }, void> =>
  useMutation(
    ({ expenseId, expense }: { expenseId: string; expense: any }) => ExpenseService.deleteExpense(expenseId, expense),
    {
      onSuccess: () => {
        AlertAdapter('Ticket Successfully Reopened', 'success');
      },
      onError: (e: Error) => {
        AlertAdapter(e.message, 'error');
      },
    }
  );

export const useProcessBilling = (): UseMutationResult<
  any,
  Error,
  {
    action: string;
    query: {
      status: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string;
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      fromDate?: string | null;
      toDate?: string | null;
    };
  }
> => {
  const queryClient = useQueryClient();

  return useMutation(payload => ExpenseService.processBilling(payload), {
    onSuccess: () => {
      // 🔥 THIS refreshes the invoice list
      queryClient.invalidateQueries({
        queryKey: ['expense-list'],
      });
    },

    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
};

export const useProcessPay = (): UseMutationResult<
  any,
  Error,
  {
    action: string;
    query: {
      status: string[];
      companyId?: string;
      employmentType?: string;
      changeType?: string;
      employmentStatus?: string;
      clientName?: string;
      hireType?: string;
      workerName?: string;
      dateRangeType?: string;
      fromDate?: string | null;
      toDate?: string | null;
    };
  }
> => {
  const queryClient = useQueryClient();

  return useMutation(payload => ExpenseService.processPay(payload), {
    onSuccess: () => {
      // 🔄 refresh invoice list after pay processing
      // queryClient.invalidateQueries({
      //   queryKey: ['invoice-list'],

      // });

      queryClient.invalidateQueries({ queryKey: ['invoice-pay-list'] });
    },

    onError: (e: Error) => {
      AlertAdapter(e.message, 'error');
    },
  });
};
